import { useQuery } from '@tanstack/react-query';
import { fetchCourseOutline } from '../api/LearnerCourseOutline';


export default function useFetchCourseOutline(courseId) {
    return useQuery({
        queryKey: ['coures-outline', courseId],
        queryFn: () => fetchCourseOutline(courseId),
    },
        {
            enabled: true,
        }
    )
}
